module.exports = __webpack_public_path__ + "img/FirstAid.61971c7a.png";